import React, { useEffect, useState } from "react";
import Breadcrumb from "../../utils/Breadcrumb";
import { Link, NavLink, Outlet, useLocation, useParams } from "react-router-dom";
import { GetAccess } from "../../utils/RolesandAccess";

function MainStandardSettings() {
  const location = useLocation();
  let pathFile = location.pathname;
  const {stdId} = useParams();
  const [labelFile, setLabelFile] = useState("Company Info");

  let LinkItem = [
    {
      label: "Status",
      link: `/standard/${stdId}/settings/status`,
    },
    {
      label: "Frequency",
      link: `/standard/${stdId}/settings/frequency`,
    },
    {
      label: "Vendor Type",
      link: `/standard/${stdId}/settings/vendor-type`,
    },
    {
      label: "Incident Type",
      link: `/standard/${stdId}/settings/incident-type`,
    },
    {
      label: "Manual Status",
      link: `/standard/${stdId}/settings/manual-status`,
    },
    {
      label: "Approval Status",
      link: `/standard/${stdId}/settings/approval-status`,
    },
    {
      label: "Internal Audit Definition",
      link: `/standard/${stdId}/settings/internal-audit-definition`,
    },
    {
      label: "Email Templates",
      link: `/standard/${stdId}/settings/email-templates`,
    },

  ];

  useEffect(() => {
    if (location.pathname == `/standard/${stdId}/settings/status`) {
      setLabelFile("Status");
    } else if (location.pathname == `/standard/${stdId}/settings/frequency`) {
      setLabelFile("Frequency");
    } else if (location.pathname == `/standard/${stdId}/settings/vendor-type`) {
      setLabelFile("Vendor Type");
    } else if (location.pathname == `/standard/${stdId}/settings/incident-type`) {
      setLabelFile("Incident Type");
    } else if (location.pathname == `/standard/${stdId}/settings/manual-status`) {
      setLabelFile("Manual Status");
    } else if (location.pathname == `/standard/${stdId}/settings/approval-status`) {
      setLabelFile("Approval Status");
    }else if (location.pathname == `/standard/${stdId}/settings/internal-audit-definition`) {
      setLabelFile("Internal Audit Definition");
    }else if (location.pathname == `/standard/${stdId}/settings/email-templates`) {
      setLabelFile("Email Templates");
    } 
  }, [location.pathname]);
  return (
      <div className="w-[100%] h-[calc(100vh-80px)]">
        <div className=" w-[92%] mx-auto">
          <Breadcrumb
            items={[
              {
                name: "Standard Settings",
              },
              {
                name: labelFile,
              },
            ]}
          />
        </div>
        <div className=" w-[97%] mx-auto h-[calc(100vh-100px)] pt-2 pb-1 grid grid-cols-12 gap-4 ">
          <div className=" col-span-2 bg-white h-full rounded-md overflow-hidden px-2 pt-4 shadow-box">
            <ul className="">
              {LinkItem &&
                LinkItem.map((item, index) => {
                  return (
                    <React.Fragment key={index}>
                      {GetAccess("admin_view") && (
                        <NavLink to={item?.link} >
                          <li className={`p-1.5 ${item?.link == pathFile ? "bg-navhover":""} my-0.5 text-xs 2xl:text-[13px] rounded-md hover:bg-navhover`}>
                            {item?.label}
                          </li>
                        </NavLink>
                      )}
                    </React.Fragment>
                  );
                })}
            </ul>
          </div>
          <div className=" col-span-10 bg-white h-full rounded-md overflow-hidden px-2 pt-4 shadow-box">
            <Outlet/>
          </div>
        </div>
      </div>

  );
}

export default MainStandardSettings;
